import idx from 'idx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import { watch, unwatch } from 'project/ducks/watchlist';
import { getSubCategory, getCategory } from 'project/ducks/project';
import Menu from 'explore/components/project_menu';

export function mapStateToProps(state, { project }) {
  const isCreative = idx(state, _ => _.user.profile_data.is_creative) || false;
  const isClient = idx(state, _ => _.user.profile_data.is_client) || false;
  const isLoggedIn = state.user.logged_in;
  const category = getCategory(project, state.categories.data) || {};
  const subCategory = getSubCategory(project, state.categories.data) || {};

  return {
    isCreative,
    isClient,
    isLoggedIn,
    category,
    subCategory,
    project,
    user: state.user.profile_data,
  };
}

export function mapDispatchToProps(dispatch, { project }) {
  return bindActionCreators({
    watch: partial(watch, project.id),
    unwatch: partial(unwatch, project.id),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu);



// WEBPACK FOOTER //
// ./explore/containers/project_menu.jsx